// Complex example: a root journey with two branching questions that keeps going,
// a nested sub-journey, and a multi-trigger sub-journey. Touchpoints embedded.
const tp = (touchpoint_id, journey_id, ordinal, name, message, wait_time, response_attribute_id = null) =>
  ({ touchpoint_id, journey_id, ordinal, name, message, wait_time, response_attribute_id, link: null });

export const journeys = [
  { journey_id: 1, name: 'Pet DNA Kit', state_enum: 'LIVE', is_active: true, segment_id: 2000, channels: ['SMS'], touchpoints: [
    tp(100, 1, 0, 'Welcome', 'Thanks for your kit!', 'P0D'),
    tp(101, 1, 1, 'Allergies?', 'Does your dog have allergies? Y/N', 'P2D', 501),
    tp(102, 1, 2, 'Diet preference?', 'Standard or Premium?', 'P2D', 502),
    tp(103, 1, 3, 'Loyalty offer', 'Here is 10% off.', 'P3D'),
  ] },
  { journey_id: 2, name: 'Has Allergies', state_enum: 'LIVE', is_active: true, segment_id: 2001, channels: ['SMS'], touchpoints: [
    tp(110, 2, 0, 'Hypoallergenic guide', 'Care tips for allergies.', 'P0D'),
    tp(111, 2, 1, 'Severe?', 'Is it severe? Y/N', 'P3D', 503),
  ] },
  { journey_id: 3, name: 'Standard Care', state_enum: 'LIVE', is_active: true, segment_id: 2002, channels: ['SMS'], touchpoints: [
    tp(120, 3, 0, 'Care tips', 'General care.', 'P1D'),
  ] },
  { journey_id: 4, name: 'Premium Diet', state_enum: 'LIVE', is_active: true, segment_id: 2003, channels: ['SMS'], touchpoints: [
    tp(130, 4, 0, 'Premium plan', 'Your premium plan.', 'P1D'),
  ] },
  { journey_id: 5, name: 'Vet Referral', state_enum: 'LIVE', is_active: true, segment_id: 2004, channels: ['SMS'], touchpoints: [
    tp(140, 5, 0, 'Find a vet', 'Vets near you.', 'P1D'),
  ] },
  { journey_id: 6, name: 'VIP Combo', state_enum: 'LIVE', is_active: true, segment_id: 2005, channels: ['SMS'], touchpoints: [
    tp(150, 6, 0, 'VIP welcome', 'Welcome to VIP.', 'P2D'),
  ] },
];

export const journeyById = (id) => journeys.find((j) => j.journey_id === id) || null;
export const touchpointsOf = (journeyId) => {
  const j = journeyById(journeyId);
  return j ? [...j.touchpoints].sort((a, b) => a.ordinal - b.ordinal) : [];
};
